<template>
  <v-card class="mx-auto mt-12" max-width="450">
    <v-toolbar flat color="transparent">
      <v-btn icon>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <!-- {{bodydatas}} -->
      <!-- {{filteredBalance}} -->
      <v-text-field
        hide-details="auto"
        v-model="search"
        dense
        outlined
        hide-no-data
        clearable
        placeholder="Search"
        append-icon="mdi-magnify"
      ></v-text-field>
    </v-toolbar>
    <v-list three-line>
      <v-list-item v-for="(item, i) in searching" :key="i" ripple>
        <v-list-item-content @click="getTemplateBodyData(item)">
          <v-list-item-title v-html="item.title"></v-list-item-title>
          <v-list-item-subtitle v-html="item.body"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  props: {
    filteredBalance: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    templateData: [],
    search: '',
    isLoading: false,
    name: '',
  }),
  created() {
    this.searchTemplate();
  },

  methods: {
    searchTemplate() {
      this.isLoading = true;

      this.$store
        .dispatch('sms/searchTemplate')
        .then((res) => {
          this.templateData = res.data.data;
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error('SMS Send failed');
          this.messages = err.data.title;
          this.isLoading = false;
        });
    },
    getTemplateBodyData(item) {
      this.$emit('change', item.body);
    },
  },

  computed: {
    keywords() {
      if (!this.search) return [];
      const keywords = [];
      for (const search of this.searching) {
        keywords.push(search.keyword);
      }

      return keywords;
    },
    searching() {
      // this.searchTemplate()
      if (!this.search) return this.templateData;

      const search = this.search.toLowerCase();

      return this.templateData.filter((item) => {
        const text = item.title.toLowerCase();

        return text.indexOf(search) > -1;
      });
    },
  },
};
</script>
